<template>
	<div class="addr-msg-page">


		<!-- 面包屑导航 -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">当前位置：</span>
				<span class="crumb-home">地址管理</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">{{ isEditMode ? '编辑收件人' : '新增收件人' }}</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>

	
		
		<!-- ====== 表单卡片 ====== -->
		<div class="form-card animate__animated  ">
			<!-- 标题 -->
			<div class="form-title-row">
				<el-image class="form-title-icon" :src="require('@/static/CodeBuddyAssets/30841_3727/10.svg')"></el-image>
				<h3 class="form-title">{{ isEditMode ? '编辑收件人' : '新增收件人' }}</h3>
			</div>
			
			<!-- Tab切换：送货上门 / 自提 -->
			<div class="addr-tab-bar">
				<div class="tab-options">
					<span class="addr-tab" :class="{ 'addr-tab-active': addrTab === 'deliver' }" @click="addrTab = 'deliver'">送货上门</span>
					<span class="addr-tab" :class="{ 'addr-tab-active': addrTab === 'pickup' }" @click="addrTab = 'pickup'">自提</span>
				</div>
			</div>
		
			<!-- 送货上门 -->
			<div class="form-body" v-if="addrTab==='deliver'">
				<!-- 左列 -->
				<div class="form-col">
					<div class="form-item">
						<label class="form-label">收件人</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.name" placeholder="请输入收件人名字" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">国家</label>
						<div class="form-input-wrap country-field">
							<div class="country-trigger" @click="toggleCountryPanel">
								<span v-if="selectedCountryName" class="country-trigger-value">{{selectedCountryName}}</span>
								<span v-else class="country-trigger-placeholder">请选择</span>
								<i class="el-icon-arrow-down country-trigger-arrow" :class="{ 'arrow-up': showCountryPanel }"></i>
							</div>
							<div class="country-panel" v-show="showCountryPanel" @click.stop>
								<div class="country-search">
									<el-input v-model="searchKeyword" placeholder="搜索国家/地区" class="country-search-input" clearable>
										<i slot="prefix" class="el-icon-search"></i>
									</el-input>
								</div>
								<div class="country-body">
									<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
										<template v-for="group in filteredCountries">
											<div class="country-group" :key="group.letter" :data-letter="group.letter">
												<div class="country-group-title">{{group.letter}}</div>
												<div class="country-item" :class="{ active: formData.country === item.value }" v-for="item in group.items" :key="item.value" @click="selectCountry(item)">
													<span class="country-name">{{item.label}}</span>
												</div>
											</div>
										</template>
										<div v-if="filteredCountries.length === 0" class="country-empty">无匹配结果</div>
									</div>
									<div class="country-index">
										<span v-for="letter in availableLetters" :key="letter" class="country-index-item" :class="{ active: activeLetter === letter }" @click="scrollToLetter(letter)">{{letter}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">城区</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.city" placeholder="请输入城市" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">城区</label>
						<div class="tp-options" style="width: 100%;" >
							<div class="tp-radio" :class="{ 'tp-radio-active': isDefault === true }" @click="isDefault = true">
								<el-image :src="isDefault === true ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
								<span>是</span>
							</div>
							<div class="tp-radio" :class="{ 'tp-radio-active': isDefault === false }" @click="isDefault = false">
								<el-image :src="isDefault === false ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
								<span>否</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 右列 -->
				<div class="form-col">
					<div class="form-item">
						<label class="form-label">手机号码</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.phone" placeholder="请输入手机号码" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">城市</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.provinceName" placeholder="请输入城区" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">详细地址</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.address" placeholder="请输入详细地址" size="large"></el-input>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 自提 -->
			<div class="form-body form-body-n" v-if="addrTab==='pickup'">
				<!-- 自提点 -->
				<div class="recipient-row-w">
					<div class="recipient-row">
						<div class="select-box" @click="link('/userPageLab/myAddrMsgMore')">选择提货点</div>
						<div class="address-card" v-if="selectedSite">
							<el-image class="addr-icon" :src="require('@/static/CodeBuddyAssets/30856_3166/16.svg')"></el-image>
							<span class="addr-name">{{selectedSite.name||'--'}}</span>
							<div class="addr-point">{{selectedSite.consignee||'--'}}&emsp;{{selectedSite.mobile||'--'}}</div>
							<div class="addr-detail">
								<span class="addr-country">{{selectedSite.countryName||'--'}}</span>
								<span class="addr-street">{{selectedSite.provinceName||''}}{{selectedSite.cityName||''}}{{selectedSite.address||''}}</span>
							</div>
						</div>
					</div>
				</div>
				<!-- 表单 -->
				<div class="form-col form-col-s f-bct">
					<div class="form-item">
						<label class="form-label">收件人</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.name" placeholder="请输入收件人名字" size="large"></el-input>
						</div>
					</div>
					<div class="form-item">
						<label class="form-label">手机号码</label>
						<div class="form-input-wrap">
							<el-input v-model="formData.phone" placeholder="请输入手机号码" size="large"></el-input>
						</div>
					</div>
					<div class="transport-item">
						<span class="tp-label">是否默认</span>
						<div class="tp-options">
							<div class="tp-radio" :class="{ 'tp-radio-active': isDefault === true }" @click="isDefault = true">
								<el-image :src="isDefault === true ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
								<span>是</span>
							</div>
							<div class="tp-radio" :class="{ 'tp-radio-active': isDefault === false }" @click="isDefault = false">
								<el-image :src="isDefault === false ? require('@/static/add2/37.png') : require('@/static/add2/38.png')"></el-image>
								<span>否</span>
							</div>
						</div>
					</div>
					<!-- <div class="form-item">
						<label class="form-label">国家</label>
						<div class="form-input-wrap country-field">
							<div class="country-trigger" @click="toggleCountryPanel">
								<span v-if="selectedCountryName" class="country-trigger-value">{{selectedCountryName}}</span>
								<span v-else class="country-trigger-placeholder">请选择</span>
								<i class="el-icon-arrow-down country-trigger-arrow" :class="{ 'arrow-up': showCountryPanel }"></i>
							</div>
							<div class="country-panel" v-show="showCountryPanel" @click.stop>
								<div class="country-search">
									<el-input v-model="searchKeyword" placeholder="搜索国家/地区" class="country-search-input" clearable>
										<i slot="prefix" class="el-icon-search"></i>
									</el-input>
								</div>
								<div class="country-body">
									<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
										<template v-for="group in filteredCountries">
											<div class="country-group" :key="group.letter" :data-letter="group.letter">
												<div class="country-group-title">{{group.letter}}</div>
												<div class="country-item" :class="{ active: formData.country === item.value }" v-for="item in group.items" :key="item.value" @click="selectCountry(item)">
													<span class="country-name">{{item.label}}</span>
												</div>
											</div>
										</template>
										<div v-if="filteredCountries.length === 0" class="country-empty">无匹配结果</div>
									</div>
									<div class="country-index">
										<span v-for="letter in availableLetters" :key="letter" class="country-index-item" :class="{ active: activeLetter === letter }" @click="scrollToLetter(letter)">{{letter}}</span>
									</div>
								</div>
							</div>
						</div>
					</div> -->
				</div>
			</div>
		</div>
		
		<!-- 保存按钮 -->
		<div class="form-footer">
			<div class="save-btn" @click="submitForm">保存</div>
		</div>
		
	</div>
</template>

<script>
import { countrylist, memberAddressDetail, memberAddressAdd, memberAddressUpdate } from "/src/api/api.js"
// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
const CN_FIRST_LETTER = {
	'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
	'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
	'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
	'布': 'B',
	'赤': 'C',
	'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
	'俄': 'E', '厄': 'E',
	'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
	'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
	'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
	'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
	'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
	'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
	'列': 'L', '卢': 'L', '罗': 'L',
	'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
	'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
	'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
	'帕': 'P', '葡': 'P',
	'日': 'R', '瑞': 'R',
	'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
	'索': 'S',
	'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
	'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
	'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
	'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
	'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
	'赞': 'Z', '智': 'Z', '中': 'Z'
}
export default {
	name: 'myAddrMsg',
	data() {
		return {
			shua:false,
			isEditMode: false,
			editId: null,
			addrTab: 'deliver',
			formData: {
				name: '',
				country: '',
				provinceName: '',
				phone: '',
				city: '',
				address: ''
			},
			countryOptions: [],
			countryLoading: false,
			selectedSite: null,
			isDefault:false,
			// 国家选择面板
			searchKeyword: '',
			showCountryPanel: false,
			activeLetter: '',
		}
	},
	computed: {
		// 当前选中国家名称
		selectedCountryName() {
			const item = this.countryOptions.find(o => o.value === this.formData.country)
			return item ? item.label : ''
		},
		// 按首字母分组 + 搜索过滤后的列表
		filteredCountries() {
			const kw = this.searchKeyword.trim().toLowerCase()
			let list = this.countryOptions
			if (kw) {
				list = list.filter(item => String(item.label || '').toLowerCase().indexOf(kw) > -1)
			}
			return this.groupByLetter(list)
		},
		// 字母索引条：基于全部国家（不随搜索变化）
		availableLetters() {
			const set = []
			this.countryOptions.forEach(item => {
				const l = this.getFirstLetter(item.label)
				if (set.indexOf(l) === -1) set.push(l)
			})
			return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
		}
	},
	mounted() {
		// var id = this.$route.query.id
		// if (id) {
		// 	this.isEditMode = true
		// 	this.editId = id
		// 	this.loadDetail(id)
		// }
		this.loadCountryList()
		document.addEventListener('click', this.handleDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick)
	},
	watch:{
		'$route.query.shua': {
			handler(val) {
				// 后续刷新
				// console.log(111)
				if (val) {
					// 需要刷新
					var id = this.$route.query.id
					if (id) {
						this.isEditMode = true
						this.editId = id
						this.loadDetail(id)
					}else{
						this.isEditMode=false
						this.editId=null
						this.addrTab='deliver'
						this.formData={
							name: '',
							country: '',
							provinceName: '',
							phone: '',
							city: '',
							address: ''
						}
						this.countryOptions=[]
						this.countryLoading=false
						this.selectedSite=null
					}
					// 清除标记，防止刷新后重复刷新
					this.$router.replace({ query: { shua: undefined } });
				}
			}
		},
	},
	activated() {
		const point = localStorage.getItem('point');
		if (point) {
			this.selectedSite = JSON.parse(point)
			localStorage.removeItem('point');
		}
		// 首次刷新
		if(this.$route.query.shua){
			if(this.shua){return}
			this.shua = true
			// console.log(2222)
			var id = this.$route.query.id
			if (id) {
				this.isEditMode = true
				this.editId = id
				this.loadDetail(id)
			}else{
				this.isEditMode=false
				this.editId=null
				this.addrTab='deliver'
				this.formData={
					name: '',
					country: '',
					provinceName: '',
					phone: '',
					city: '',
					address: ''
				}
				this.countryOptions=[]
				this.countryLoading=false
				this.selectedSite=null
			}
		}
	},
	methods: {
		// ===== 国家选择面板相关 =====
		// 切换面板显示状态
		toggleCountryPanel() {
			this.showCountryPanel = !this.showCountryPanel
			if (this.showCountryPanel) {
				this.searchKeyword = ''
				this.activeLetter = ''
			}
		},
		// 选中国家
		selectCountry(item) {
			this.formData.country = item.value
			this.showCountryPanel = false
			this.searchKeyword = ''
		},
		// 获取当前渲染的国家列表 DOM（兼容 v-if 互斥导致的重复 ref）
		getCountryListEl() {
			const ref = this.$refs.countryList
			if (!ref) return null
			return Array.isArray(ref) ? ref[0] : ref
		},
		// 点击字母索引，锚定滚动到对应分组
		scrollToLetter(letter) {
			this.activeLetter = letter
			const listEl = this.getCountryListEl()
			if (!listEl) return
			const target = listEl.querySelector(`[data-letter="${letter}"]`)
			if (target) {
				listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		// 列表滚动时高亮当前所在字母
		onCountryListScroll() {
			const listEl = this.getCountryListEl()
			if (!listEl) return
			const scrollTop = listEl.scrollTop
			let current = ''
			listEl.querySelectorAll('[data-letter]').forEach(el => {
				if (el.offsetTop <= scrollTop + 1) {
					current = el.getAttribute('data-letter')
				}
			})
			this.activeLetter = current
		},
		// 提取首字母（兼容英文/中文，无法识别归入 #）
		getFirstLetter(name) {
			if (!name) return '#'
			const first = String(name).trim().charAt(0)
			if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
			if (/[\u4e00-\u9fa5]/.test(first)) {
				return CN_FIRST_LETTER[first] || '#'
			}
			return '#'
		},
		// 按首字母分组
		groupByLetter(list) {
			const groups = {}
			list.forEach(item => {
				const letter = this.getFirstLetter(item.label)
				if (!groups[letter]) groups[letter] = []
				groups[letter].push(item)
			})
			const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			return letters.map(l => ({ letter: l, items: groups[l] }))
		},
		// 点击面板外部关闭
		handleDocumentClick(e) {
			if (!this.showCountryPanel) return
			const fields = this.$el.querySelectorAll('.country-field')
			let inside = false
			fields.forEach(f => {
				if (f.contains(e.target)) inside = true
			})
			if (!inside) {
				this.showCountryPanel = false
			}
		},
		// 国家列表
		async loadCountryList() {
			this.countryLoading = true
			const res = await countrylist({})
			this.countryLoading = false
			if (res.code == 200) {
				var list = []
				res.rows.forEach((item) => {
					list.push({ label: item.name, value: item.id })
				})
				this.countryOptions = list
			} else {
				this.Tips(res.msg, 'error')
			}
		},
		// 编辑回显
		async loadDetail(id) {
			const res = await memberAddressDetail({ id: id })
			if (res.code == 200) {
				var item = res.data
				this.isDefault = item.isDefault?true:false
				this.formData.name = item.consignee || ''
				this.formData.country = item.countryId || ''
				this.formData.provinceName = item.provinceName || ''
				this.formData.phone = item.mobile || ''
				this.formData.city = item.cityName || ''
				this.formData.address = item.address || ''
				this.addrTab = item.addressType == 2 ? 'pickup' : 'deliver'
				if (item.addressType == 2 && item.selfPickupSite) {
					this.selectedSite = item.selfPickupSite
				}
			} else {
				this.Tips(res.msg, 'error')
			}
		},
		// 提交表单
		async submitForm() {
			if (!this.formData.name) {
				this.Tips('请填写收件人', 'error')
				return
			}
			if (!this.formData.phone) {
				this.Tips('请填写手机号码', 'error')
				return
			}
			if (this.addrTab === 'deliver') {
				if (!this.formData.country) {
					this.Tips('请选择国家', 'error')
					return
				}
				if (!this.formData.city) {
					this.Tips('请填写城市', 'error')
					return
				}
				if (!this.formData.address) {
					this.Tips('请填写详细地址', 'error')
					return
				}
			}
			if (this.addrTab === 'pickup') {
				if (!this.formData.country) {
					this.Tips('请选择国家', 'error')
					return
				}
			}
			var data = {
				isDefault:this.isDefault?1:0,
				consignee: this.formData.name,
				mobile: this.formData.phone,
				countryId: this.formData.country,
				addressType: this.addrTab === 'deliver' ? 1 : 2,
			}
			if (this.addrTab === 'deliver') {
				data.cityName = this.formData.city
				data.provinceName = this.formData.provinceName
				data.address = this.formData.address
			}
			if (this.addrTab === 'pickup' && this.selectedSite) {
				data.selfPickupSiteId = this.selectedSite.id
			}
			if (this.isEditMode) {
				data.id = this.editId
				const res = await memberAddressUpdate(data)
				if (res.code == 200) {
					this.Tips(res.msg || '修改成功')
					this.$router.back()
				} else {
					this.Tips(res.msg || '修改失败', 'error')
				}
			} else {
				const res = await memberAddressAdd(data)
				if (res.code == 200) {
					this.Tips(res.msg || '新增成功')
					this.$router.back()
				} else {
					this.Tips(res.msg || '新增失败', 'error')
				}
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.addr-msg-page {
	width: 100%;
	min-height: 100vh;
	background: #F8F8F8;
	padding-bottom: 60px;
}

/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover { color: #0096FF; }
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}

/* Tab切换 */
.addr-tab-bar {
	position: relative;
	margin-bottom: 32px;
}
.tab-options {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #F0F0F0;
}
.addr-tab {
	font-size: 18px;
	cursor: pointer;
	margin-right: 42px;
	color: #7D7D89;
	font-weight: 400;
	padding-bottom: 15px;
	position: relative;
	transition: 0.3s;
	position: relative;
	&::after{
		content: '';
		position: absolute;
		width: 0%;
		height: 4px;
		border-radius: 4px;
		left: 50%;
		bottom: -1px;
		transform: translateX(-50%);
		background: #0096FF;
		transition: 0.3s;
	}
}
.addr-tab.addr-tab-active {
	color: #0096FF;
	font-weight: 500;
	&::after{
		content: '';
		position: absolute;
		width: 90%;
		height: 4px;
		border-radius: 4px;
		left: 50%;
		bottom: -1px;
		transform: translateX(-50%);
		background: #0096FF;
		transition: 0.3s;
	}
}
.tab-underline {
	position: absolute;
	bottom: 3px;
	left: 0;
	width: 72px;
	height: 4px;
	background: #0096FF;
	border-radius: 10px;
	transition: left 0.3s;
}
.underline-right {
	left: 114px;
}
.tab-divider {
	height: 1px;
	background: #F0F0F0;
	margin-top: -4px;
}
/* ===================================================================
   表单卡片
   =================================================================== */
.form-card {
	width: 100%;
	margin: 16px auto 0;
	background: #fff;
	border-radius: 12px;
	padding: 24px 24px 40px;
	box-sizing: border-box;
}

/* 标题 */
.form-title-row {
	display: flex;
	align-items: center;
	margin-bottom: 28px;
}
.form-title-icon {
	width: 10px;
	height: 16px;
	margin-right: 12px;
}
.form-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
}
// 选择自提点
.recipient-row-w{
	padding-bottom: 12px;
}
.section-header {
	display: flex;
	align-items: center;
	margin-bottom: 24px;
}
.section-header .el-image {
	width: 4px;
	height: 16px;
	margin-right: 12px;
}
.section-title {
	font-size: 20px;
	font-weight: 500;
	color: #333;
	margin: 0;
	flex: 1;
}
.recipient-row,
.logistics-row {
	// display: flex;
	// align-items: flex-start;
	margin-bottom: 20px;
}
.select-box {
	width: 118px;
	height: 50px;
	border: 1px solid #0096FF;
	border-radius: 4px;
	text-align: center;
	line-height: 50px;
	font-size: 16px;
	font-weight: 500;
	color: #0096FF;
	cursor: pointer;
	flex-shrink: 0;
	margin-right: 32px;
	margin-bottom: 20px;
}

.address-card {
	width: 495px;
	height: 112px;
	background: #FAFAFA;
	border: 1px solid #EDEDED;
	border-radius: 4px;
	padding: 16px;
	box-sizing: border-box;
	position: relative;
}
.addr-icon {
	width: 20px;
	height: 20px;
	position: absolute;
	top: 16px;
	left: 16px;
}
.addr-name {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 28px;
}
.addr-phone {
	font-size: 16px;
	font-weight: 500;
	color: #333;
	margin-left: 8px;
}
.addr-tag {
	position: absolute;
	top: 14px;
	right: 16px;
	width: 52px;
	height: 26px;
	background: #FFEDED;
	border-radius: 4px;
	text-align: center;
	line-height: 26px;
	font-size: 12px;
	color: #FF4747;
}
.addr-point {
	font-size: 14px;
	color: #333;
	margin-top: 10px;
	margin-left: 0;
}
.addr-detail {
	display: flex;
	align-items: center;
	margin-top: 6px;
	margin-left: 0;
}
.addr-country {
	font-size: 14px;
	color: #0096FF;
}
.addr-street {
	font-size: 14px;
	color: #999;
	margin-left: 8px;
}

/* 表单主体 */
.form-body {
	display: flex;
}
.form-body-n{
	display: block;
}
.form-col {
	width: 48%;
	flex-shrink: 0;
}
.form-col-s{
	width: 100%;
	flex-shrink: 0;
	padding-right: 0!important;
	.form-item{
		width: 492px;
	}
}
.form-col:first-child {
	margin-right: 32px;
}
.form-item {
	margin-bottom: 24px;
}
.form-label {
	display: block;
	font-size: 16px;
	color: #333;
	font-weight: 400;
	margin-bottom: 10px;
}

.form-input-wrap {
	width: 100%;
}
::v-deep .el-select{
	width: 100%;
}
.form-input-wrap ::v-deep .el-input__inner,
.form-input-wrap ::v-deep .el-select .el-input__inner {
	height: 50px;
	line-height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
}
.form-input-wrap ::v-deep .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__inner::placeholder {
	color: #999;
}
.form-input-wrap ::v-deep .el-select .el-input__suffix .el-input__suffix-inner {
	display: flex;
	align-items: center;
}
.form-input-wrap ::v-deep .el-select .el-icon-arrow-up:before {
	content: '';
}
.form-input-wrap ::v-deep .el-select .el-select__caret {
	color: #333;
	font-size: 12px;
}

/* 保存按钮 */
.form-footer {
	width: 100%;
	margin: auto;
	display: flex;
	justify-content: flex-end;
	margin-top: 24px;
}
.save-btn {
	width: 184px;
	height: 50px;
	background: #0096FF;
	border-radius: 10px;
	color: #fff;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	line-height: 50px;
	cursor: pointer;
	transition: background 0.3s;
}
.save-btn:hover {
	background: #33ABFF;
}

/* ===== 国家选择面板（搜索 + 字母索引） ===== */
.country-field {
	position: relative;
}
.country-trigger {
	width: 100%;
	height: 50px;
	line-height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #333;
	padding: 0 12px;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	background: #fff;
	transition: border-color 0.3s;
	&:hover {
		border-color: #0096FF;
	}
	.country-trigger-placeholder {
		color: #999;
	}
	.country-trigger-arrow {
		color: #333;
		font-size: 12px;
		transition: transform 0.3s;
		&.arrow-up {
			transform: rotate(180deg);
		}
	}
}
.country-panel {
	position: absolute;
	top: calc(100% + 6px);
	left: 0;
	width: 100%;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.16);
	z-index: 999;
	padding: 12px;
	box-sizing: border-box;
}
.country-search {
	margin-bottom: 12px;
	::v-deep .el-input__inner {
		height: 40px;
		line-height: 40px;
		border: 1px solid #E2E6E9;
		border-radius: 4px;
		padding-left: 30px;
		font-size: 14px;
		color: #333;
	}
	::v-deep .el-input__inner:focus {
		border-color: #0096FF;
	}
	::v-deep .el-input__prefix {
		left: 8px;
		line-height: 40px;
		color: #92969F;
	}
}
.country-body {
	display: flex;
	align-items: flex-start;
}
.country-list {
	flex: 1;
	height: 320px;
	overflow-y: auto;
	padding-right: 8px;
	position: relative;
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 2px;
	}
}
.country-group-title {
	font-size: 13px;
	font-weight: 600;
	color: #0096FF;
	padding: 6px 10px;
}
.country-item {
	padding: 8px 10px;
	font-size: 14px;
	color: #333;
	cursor: pointer;
	border-radius: 4px;
	transition: background 0.2s, color 0.2s;
	&:hover {
		background: #F0F7FD;
		color: #0096FF;
	}
	&.active {
		background: #F0F7FD;
		color: #0096FF;
		font-weight: 500;
	}
}
.country-empty {
	text-align: center;
	color: #BFC6CE;
	font-size: 14px;
	padding: 40px 0;
}
.country-index {
	width: 30px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 320px;
	overflow-y: auto;
	border-left: 1px solid #F0F0F0;
}
.country-index-item {
	font-size: 12px;
	color: #666;
	cursor: pointer;
	line-height: 1.4;
	padding: 1px 0;
	transition: color 0.2s;
	&:hover,
	&.active {
		color: #0096FF;
		font-weight: 600;
	}
}
/* ===== 运输信息 ===== */
.transport-row {
	display: flex;
	margin-bottom: 24px;
}
.transport-item {
	display: flex;
	align-items: center;
	margin-right: 40px;
}
.transport-item:last-child {
	margin-right: 0;
}
.tp-label {
	font-size: 16px;
	color: #333;
	white-space: nowrap;
	margin-right: 16px;
}
.tp-label-red {
	color: #FC3C3C;
}
.tp-options {
	display: flex;
	align-items: center;
	width: 382px;
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	padding: 0 16px;
	box-sizing: border-box;
}
.tp-radio {
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-right: 32px;
	position: relative;
}
.tp-radio:last-child {
	margin-right: 0;
}
.tp-radio .el-image {
	width: 22px;
	height: 22px;
}
.radio-inner {
	position: absolute;
	left: 4px;
	top: 4px;
	width: 14px;
	height: 14px;
}
.tp-radio span {
	font-size: 16px;
	color: #333;
	margin-left: 8px;
}
.tp-select-wrap {
	width: 362px;
	height: 50px;
	::v-deep .el-input__inner {
		height: 100%!important;
	}
	::v-deep .el-input {
		height: 100%;
	}
	::v-deep .el-select {
		width: 100%;
		height: 100%;
	}
}
.tp-select {
	width: 100%;
	height: 50px;
}
.tp-select ::v-deep .el-input__inner {
	height: 50px;
	border: 1px solid #D9D9D9;
	border-radius: 4px;
	font-size: 16px;
	color: #999;
}
</style>
